export enum EStaticCategory {
  All = 'ALL',
  ZipMoneyDeals = 'ZIP_MONEY_DEALS',
  OtherDeals = 'OTHER_DEALS',
}

export interface Category {
  id: string;
  name: string;
  productIds: string[];
  createdAt: string;
  updatedAt: string;
}

export interface ShopCategory {
  entryId: String;
  id: String;
  name: String;
}
